export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/blueHomeIcon.53899be1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};